var _path, _path2, _path3, _rect, _g, _path4, _path5, _rect2, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiwi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135 270C60.4 270 0 209.6 0 135C0 60.4 60.4 0 135 0C209.6 0 270 60.4 270 135C270 209.6 209.6 270 135 270Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.719 170.234L98.7465 170.894L101.884 208.765L109.857 208.105L106.719 170.234Z",
    fill: "#1F201D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.3 170.5H143.3V208.5H151.3V170.5Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_101_39",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 83,
    y: 221,
    width: 90,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 221,
    width: 90,
    height: 15,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_101_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.8 233.5C151.272 233.5 170.3 231.261 170.3 228.5C170.3 225.739 151.272 223.5 127.8 223.5C104.328 223.5 85.3 225.739 85.3 228.5C85.3 231.261 104.328 233.5 127.8 233.5Z",
    fill: "#BFC3CE"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8 226.5C107.465 226.5 115.3 221.575 115.3 215.5C115.3 209.425 107.465 204.5 97.8 204.5C88.1351 204.5 80.3 209.425 80.3 215.5C80.3 221.575 88.1351 226.5 97.8 226.5Z",
    fill: "#1F201D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M155.8 226.5C165.465 226.5 173.3 221.575 173.3 215.5C173.3 209.425 165.465 204.5 155.8 204.5C146.135 204.5 138.3 209.425 138.3 215.5C138.3 221.575 146.135 226.5 155.8 226.5Z",
    fill: "#1F201D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_101_39",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 162,
    y: 208,
    width: 10,
    height: 10
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 162,
    y: 208,
    width: 10,
    height: 10,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_101_39)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.8 215.5C168.181 215.5 169.3 214.381 169.3 213C169.3 211.619 168.181 210.5 166.8 210.5C165.419 210.5 164.3 211.619 164.3 213C164.3 214.381 165.419 215.5 166.8 215.5Z",
    fill: "white"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1001 114.4C72.1001 114.4 52.4001 144.7 60.9001 166.6",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5 192C162.466 192 190 158.869 190 118C190 77.1309 162.466 44 128.5 44C94.5345 44 67 77.1309 67 118C67 158.869 94.5345 192 128.5 192Z",
    fill: "#A36903"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.712 191.901C139.723 188.257 151.61 180.967 159.496 169.877C171.904 152.427 176.556 139.083 176.556 111.881C176.556 90.1192 162.425 69.6236 155.36 62.096C150.961 57.2615 138.085 47.6788 119.551 44.7777C122.473 44.2653 125.461 44 128.5 44C162.465 44 190 77.1309 190 118C190 157.573 164.185 189.89 131.712 191.901Z",
    fill: "#965209"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M182.4 126.7C182.4 126.7 202.4 113.7 199.4 93.7C199.4 93.7 206.4 83.7 202.4 74.7",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M190.4 85.7C190.4 85.7 192.4 95.7 199.4 93.7C206.4 91.7 212.6 88.7 211 79.2",
    stroke: "#3A3A3A",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.8 118.5C111.39 118.5 114.3 115.59 114.3 112C114.3 108.41 111.39 105.5 107.8 105.5C104.21 105.5 101.3 108.41 101.3 112C101.3 115.59 104.21 118.5 107.8 118.5Z",
    fill: "#4C1A1D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.8 118.5C153.39 118.5 156.3 115.59 156.3 112C156.3 108.41 153.39 105.5 149.8 105.5C146.21 105.5 143.3 108.41 143.3 112C143.3 115.59 146.21 118.5 149.8 118.5Z",
    fill: "#4C1A1D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M141.2 126.5C142.7 132.4 139.2 138.4 133.4 139.9C127.5 141.4 121.5 137.9 120 132.1",
    fill: "#FFF3F3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7 46.5C127.357 46.5 128.7 45.6046 128.7 44.5C128.7 43.3954 127.357 42.5 125.7 42.5C124.043 42.5 122.7 43.3954 122.7 44.5C122.7 45.6046 124.043 46.5 125.7 46.5Z",
    fill: "#009D00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.7 45.5C131.357 45.5 132.7 44.6046 132.7 43.5C132.7 42.3954 131.357 41.5 129.7 41.5C128.043 41.5 126.7 42.3954 126.7 43.5C126.7 44.6046 128.043 45.5 129.7 45.5Z",
    fill: "#723C06"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 48.5C130.357 48.5 131.7 47.6046 131.7 46.5C131.7 45.3954 130.357 44.5 128.7 44.5C127.043 44.5 125.7 45.3954 125.7 46.5C125.7 47.6046 127.043 48.5 128.7 48.5Z",
    fill: "#723C06"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M124.7 49.5C126.357 49.5 127.7 48.6046 127.7 47.5C127.7 46.3954 126.357 45.5 124.7 45.5C123.043 45.5 121.7 46.3954 121.7 47.5C121.7 48.6046 123.043 49.5 124.7 49.5Z",
    fill: "#723C06"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M122.7 46.5C124.357 46.5 125.7 45.6046 125.7 44.5C125.7 43.3954 124.357 42.5 122.7 42.5C121.043 42.5 119.7 43.3954 119.7 44.5C119.7 45.6046 121.043 46.5 122.7 46.5Z",
    fill: "#723C06"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7 40.5C127.357 40.5 128.7 39.6046 128.7 38.5C128.7 37.3954 127.357 36.5 125.7 36.5C124.043 36.5 122.7 37.3954 122.7 38.5C122.7 39.6046 124.043 40.5 125.7 40.5Z",
    fill: "#723C06"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M128.7 38.5H122.7V46.5H128.7V38.5Z",
    fill: "#723C06"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_101_39",
    transform: "scale(0.0111111 0.0666667)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_101_39",
    transform: "scale(0.1)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_101_39",
    width: 90,
    height: 15,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAGjAAACAAAAAsj/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAA8AWgMBIgACEQEDEQH/xACGAAACAwEAAAAAAAAAAAAAAAAEBgABBQMBAQAAAAAAAAAAAAAAAAAAAAAQAAEEAgMBAQAAAAAAAAAAAAUAAQMGAgQWBxcgEREAAQIDBQYFBQAAAAAAAAAAAQACEQMEITFB0RKRoZKTBTUQsYPTFHGBUsIjEgEAAAAAAAAAAAAAAAAAAAAg/9oADAMBAAIRAxEAAABNZlhmDyxCzrJCVdAIpQgu5OrlH//aAAgBAgABBQD6/9oACAEDAAEFAPr/2gAIAQEAAQUAHCNwlnrda78jt1hCoOtRWGHnANecA15wDWXW4Z2frCBbXWeziiVbIjnQ6UrFJrHr1Fk1ruTKC3WFsOXmVy8yuXmVlbjf49suLrbsV5mRLZsE7r//2gAIAQICBj8AX//aAAgBAwIGPwBf/9oACAEBAQY/AA2nAhGBcSmmbUNbLN8Bb5q2rfsGSAnTHzHflEjygr38RzV7+I5q9/Ec0Q1zwcDqOasq3w+gyQNNUgjHWIndBOMwNexuLTbs8A7p4mudG6W0v3AFNPwKiYwXt+PNt+8CuyVB9Gb7aHyOhVmvHRImEb2hdhruQ/JdhruQ/JdhruQ/JHR0KtBwjIfkrOiVA9Gb7aGjplRJbj/Caf1Cca5k9jTe10tzANo8P//Z"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_101_39",
    width: 10,
    height: 10,
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAgEASABIAAD/7AARRHVja3kAAQAEAAAAHgAA/+4AIUFkb2JlAGTAAAAAAQMAEAMCAwYAAAF3AAABiAAAAbX/2wCEABALCwsMCxAMDBAXDw0PFxsUEBAUGx8XFxcXFx8eFxoaGhoXHh4jJSclIx4vLzMzLy9AQEBAQEBAQEBAQEBAQEABEQ8PERMRFRISFRQRFBEUGhQWFhQaJhoaHBoaJjAjHh4eHiMwKy4nJycuKzU1MDA1NUBAP0BAQEBAQEBAQEBAQP/CABEIAAoACgMBIgACEQEDEQH/xABrAAEBAQAAAAAAAAAAAAAAAAAABQYBAQAAAAAAAAAAAAAAAAAAAAAQAAIDAAAAAAAAAAAAAAAAAAAFEAQGEQAABQUAAAAAAAAAAAAAAAARMRIDBCABAiIyEgEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAAACDnQ//2gAIAQIAAQUAP//aAAgBAwABBQA//9oACAEBAAEFAFihNYz8/wD/2gAIAQICBj8Af//aAAgBAwIGPwB//9oACAEBAQY/AJE2Q+mY2pOI8gWtjo//2Q=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiwi);
export default __webpack_public_path__ + "static/media/kiwi.4229665bec69d59200693123dca4ca2a.svg";
export { ForwardRef as ReactComponent };